import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M4.758 6.458c0-.92.746-1.666 1.667-1.666h8.75c.92 0 1.666.746 1.666 1.666v7.084c0 .92-.746 1.666-1.666 1.666h-8.75c-.92 0-1.667-.746-1.667-1.666V6.458Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="m5.383 5.417 5.417 4.791 5.416-4.791" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);